export default "__VITE_ASSET__BV3V1eHK__"